import React, { useState } from 'react'

import { Subscription } from '../types'
import Input from './Input'

interface SubscribeFormProps {
	description: string
	onSubscribe: (subscription: Subscription) => void
}

const initialData = {
	firstname: '',
	lastname: '',
	email: '',
}

const SubscribeForm: React.FC<SubscribeFormProps> = props => {
	const [data, setData] = useState<Subscription>(initialData)

	const handleChange = (field: keyof Subscription) => (value: string) => {
		setData({
			...data,
			[field]: value,
		})
	}

	const handleSubmit = (event: React.SyntheticEvent) => {
		event.preventDefault()

		if ((event.target as HTMLFormElement).checkValidity()) {
			props.onSubscribe(data)
			setData(initialData)
		}
	}

	return (
		<div className="grid__col grid__col--10 grid__col--offset-1 grid__col--spacing">
			<div className="product product--border">
				<div className="grid">
					<div className="grid__col grid__col--12 grid__col--spacing-bottom">
						<p className="text text--align-justify">
							{props.description}
						</p>
					</div>

					<form method="POST" onSubmit={handleSubmit}>
						<div className="grid__row">
							<div className="grid__col grid__col--12">
								<Input label="Voornaam" value={data.firstname} onChange={handleChange('firstname')} required />
							</div>

							<div className="grid__col grid__col--12">
								<Input label="Achternaam" value={data.lastname} onChange={handleChange('lastname')} required />
							</div>
						</div>

						<div className="grid__col grid__col--12">
							<Input type="email" label="Email" value={data.email} onChange={handleChange('email')} required />
						</div>

						<div className="grid__col grid__col--12 grid__col--spacing">
							<button type="submit" className="button button--primary">Schrijf mij in!</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default SubscribeForm
